
import { RevCardCarousel, RevToast } from '@backmarket/design-system'
import isEmpty from 'lodash/isEmpty'
import { mapGetters } from 'vuex'

import { CAT_CAMPAIGN_EVENT_PAGE } from '@campaigns/cat/catpaign.constants'
import { TOAST_CROSS_SELL } from '@config/constants/toasts'
import { logger } from '@recommendation/helpers'
import { trackProductImpressionBatched } from '@tracking/events'

import CarouselSkeleton from './CarouselSkeleton.vue'
import ProductCardContainer from './ProductCardContainer.vue'
import translations from './RecommendedProductsCarousel.translations'

const TOAST_VARIANT = {
  SUCCESS: 'success',
  ERROR: 'error',
}

export default {
  components: {
    RevCardCarousel,
    CarouselSkeleton,
    RevToast,
    ProductCardContainer,
  },

  props: {
    products: {
      type: Array,
      required: true,
    },

    isLoading: {
      type: Boolean,
      default: false,
    },

    widgetId: {
      type: String,
      required: true,
    },

    list: {
      type: String,
      required: true,
    },

    withAddToCart: {
      type: Boolean,
      default: false,
    },

    withCrossedPrice: {
      type: Boolean,
      default: false,
    },

    withStartingFrom: {
      type: Boolean,
      default: true,
    },

    withGrade: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      productImpressions: [],
      toast: {
        icon: '',
        isOpened: false,
        message: '',
        title: '',
        variant: '',
      },
      trackingInterval: null,
    }
  },

  computed: {
    ...mapGetters({
      experiments: 'flags/getExperiments',
      country: 'config/country',
    }),

    TOAST_CROSS_SELL: () => TOAST_CROSS_SELL,

    translations: () => translations,

    toastSuccess() {
      return {
        title: this.$t(translations.toastSuccessTitle),
        message: this.$t(translations.toastSuccessMessage),
        icon: this.$static('/img/toast/rabbit.svg'),
        variant: TOAST_VARIANT.SUCCESS,
      }
    },

    toastError() {
      return {
        title: this.$t(translations.toastErrorTitle),
        message: this.$t(translations.toastErrorMessage),
        icon: this.$static('/img/toast/storm.svg'),
        variant: TOAST_VARIANT.ERROR,
      }
    },

    listeners() {
      return this.withAddToCart
        ? { ...this.$listeners, 'add-to-cart': this.addToCart }
        : this.$listeners
    },

    desktopCardWidth() {
      return 'standard'
    },

    // TODO: [SR-1594] Clean AB test for larger vertical card outside of add to cart
    mobileCardWidth() {
      if (this.withAddToCart) {
        return 'standard'
      }

      switch (this.experiments.cartRecommendationBlockV2) {
        case 'recommendationBlockV2':
          return 'standard'
        case 'recommendationBlockV1':
        default:
          return 'narrow'
      }
    },

    // TODO: [LIF-373] Remove after cat campaign
    isCatEventPage() {
      const {
        params: { pageName },
      } = this.$route

      return CAT_CAMPAIGN_EVENT_PAGE.includes(pageName)
    },

    // TODO: [LIF-373] Remove after cat campaign
    isCatCampaignEnabled() {
      return (
        this.isCatEventPage &&
        this.$config.FF_CAT_CAMPAIGN_BY_COUNTRY?.includes(this.country)
      )
    },
  },

  mounted() {
    this.trackingInterval = setInterval(() => {
      if (!isEmpty(this.productImpressions)) {
        try {
          trackProductImpressionBatched(this.productImpressions)
        } catch (err) {
          logger.info(err, {
            component: {
              name: 'RecommendedProductsCarousel',
              props: this.$props,
            },
            routeName: this.$route.name,
          })
        } finally {
          this.productImpressions = []
        }
      }
    }, this.$config.BATCH_TRACKING_INTERVAL)
  },

  beforeDestroy() {
    clearInterval(this.trackingInterval)
  },

  methods: {
    saveImpression(productTracking) {
      this.productImpressions.push(productTracking)
    },

    addToCart({ success, listingId }) {
      if (success) {
        this.toast = this.toastSuccess

        this.$emit('add-to-cart', { listingId })
      } else {
        this.toast = this.toastError
      }

      this.toast.isOpened = true
    },

    closeToast() {
      this.toast = { ...this.toast, isOpened: false }
    },
  },
}
